/**
 * UI permission-keys for the `PERSON` route (People screen).
 *
 * Only the listing is gated — `/people/$personId` and `/people/new` stay
 * ungated deep-links (citations, favourites, appointing a director from
 * entity onboarding), same as before the People directory was re-added.
 */
export const PersonAclKeys = {
  /** Access to the /people (People) listing. */
  listingRead: 'people:listing:read',
  /**
   * FR-F3a — capture an email on a blocked (`NO_EMAIL_PENDING`/`CONFLICT_PENDING`) person.
   *
   * Also reused (codex-qa round 8, T0297) to gate PersonDetailPage's Edit/Archive/Add Address/End
   * Address — the CSV row maps this key to the SAME (`entity-setup`, `write`) pair that
   * `updateNaturalPerson`/`archiveNaturalPerson` require server-side, so it resolves correctly for
   * that purpose too. Same reuse pattern as `EntityAclKeys.entitySetupWrite` on entity-detail.
   */
  identityWrite: 'people:identity:write',
  /** FR-F8 — the tenant's unresolved-identity queue (T07/T11-13; deferred). */
  unresolvedRead: 'people:unresolved:read',
  /** Admin-only identity actions on the unresolved queue (manual-assign, dispose; deferred). */
  identityAdmin: 'people:identity:admin',
} as const;

export type PersonAclKey = (typeof PersonAclKeys)[keyof typeof PersonAclKeys];
